export default __webpack_public_path__ + "static/7-cbef929f745d47e4eaa04f95aa9617ed.webp";